import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import ExpansionPanel, {
  ExpansionPanelDetails,
  ExpansionPanelSummary,
} from 'material-ui/ExpansionPanel';
import Icon from '../Icon';

export class Accordion extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      expanded: true,
    };
  }

  handleChange(event, expanded) {
    this.setState({
      expanded,
    });
  }

  render() {
    return (
      <div className="orderSummary accordion">
        <ExpansionPanel expanded={this.state.expanded} onChange={this.handleChange}>
          <ExpansionPanelSummary className="header">
            <Icon
              {...(this.state.expanded ? { icon: 'minus' } : { icon: 'plus' })}
              alt="Order Received"
            />
            <div className="title font-lato">{this.props.title}</div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className="font-body accordion-container">
            {this.props.data}
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    );
  }
}

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(Accordion);



// WEBPACK FOOTER //
// src/components/molecules/Accordion/index.jsx